"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveChallengeAsync = exports.textEncodeLite = exports.generateRandom = void 0;
const base64 = __importStar(require("base64-js"));
const crytoInfo = () => {
    const hasCrypto = typeof window !== 'undefined' && !!window.crypto;
    const hasSubtleCrypto = hasCrypto && !!window.crypto.subtle;
    return { hasCrypto, hasSubtleCrypto };
};
const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const bufferToString = (buffer) => {
    const state = [];
    for (let i = 0; i < buffer.byteLength; i += 1) {
        const index = buffer[i] % charset.length;
        state.push(charset[index]);
    }
    return state.join('');
};
const urlSafe = (buffer) => {
    const encoded = base64.fromByteArray(new Uint8Array(buffer));
    return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
};
const generateRandom = (size) => {
    const buffer = new Uint8Array(size);
    const { hasCrypto } = crytoInfo();
    if (hasCrypto) {
        window.crypto.getRandomValues(buffer);
    }
    else {
        // fall back to Math.random() if nothing else is available
        for (let i = 0; i < size; i += 1) {
            buffer[i] = (Math.random() * charset.length) | 0;
        }
    }
    return bufferToString(buffer);
};
exports.generateRandom = generateRandom;
function textEncodeLite(str) {
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0; i < str.length; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return bufView;
}
exports.textEncodeLite = textEncodeLite;
const deriveChallengeAsync = (code) => {
    if (code.length < 43 || code.length > 128) {
        return Promise.reject(new Error('Invalid code length.'));
    }
    const { hasSubtleCrypto } = crytoInfo();
    if (!hasSubtleCrypto) {
        return Promise.reject(new Error('window.crypto.subtle is unavailable.'));
    }
    return new Promise((resolve, reject) => {
        crypto.subtle.digest('SHA-256', textEncodeLite(code)).then(buffer => {
            return resolve(urlSafe(new Uint8Array(buffer)));
        }, error => reject(error));
    });
};
exports.deriveChallengeAsync = deriveChallengeAsync;
//# sourceMappingURL=crypto.js.map